/**
 * Lead display helpers + colour constants shared across the dashboard
 * surfaces (LeadDetailPanel, DealSidebar, DashboardMap, InspectionDashboard).
 *
 * Lead marker palette — violet family, deliberately outside the verdict
 * colour set (red/amber/emerald/neutral) so leads read as a distinct layer.
 */

/** violet-400 — remarketing pool. */
export const LEAD_VIOLET = '#a78bfa';
/** violet-500 — in-area, book-worthy ("lead to book"). */
export const LEAD_TO_BOOK_VIOLET = '#8b5cf6';

/**
 * Best-effort display name for a lead contact — full name, then email, then
 * the caller-supplied fallback (defaults to "Unnamed lead"; the map passes
 * the record id instead).
 */
export function leadDisplayName(
  lead: { firstName: string | null; lastName: string | null; email: string | null },
  fallback = 'Unnamed lead',
): string {
  const full = [lead.firstName, lead.lastName].filter(Boolean).join(' ').trim();
  return full || lead.email || fallback;
}
